import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTimeout, useWindowScroll } from 'react-use';
import useIsBrowser from 'hooks/useIsBrowser';
import useElementDimensions from 'hooks/useElementDimensions';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
const ProductListingPageName = t0 => {
  const $ = _c(15);
  const {
    loading: t1,
    pageName,
    showPageNameWhileLoading: t2
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const showPageNameWhileLoading = t2 === undefined ? false : t2;
  const {
    y: t3
  } = useWindowScroll();
  const currentScrollPosition = t3 === undefined ? 0 : t3;
  const shrinkPageName = currentScrollPosition > 50;
  const titleRef = useRef(null);
  const {
    width: titleWidth
  } = useElementDimensions(titleRef);
  const [shouldResize] = useTimeout(50);
  const isBrowser = useIsBrowser();
  if (loading && !showPageNameWhileLoading) {
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <><TextPlaceholder className="!w-[250px] !h-7" />{" "}</>;
      $[0] = t4;
    } else {
      t4 = $[0];
    }
    return t4;
  }
  let isSearchResults;
  let t4;
  if ($[1] !== pageName) {
    isSearchResults = typeof pageName === "string" ? pageName.includes("Results for") : true;
    t4 = classNames("flex-shrink-0", {
      "min-w-0": isSearchResults
    });
    $[1] = pageName;
    $[2] = isSearchResults;
    $[3] = t4;
  } else {
    isSearchResults = $[2];
    t4 = $[3];
  }
  const t5 = !isSearchResults && isBrowser && shouldResize && titleWidth ? titleWidth + 5 : undefined;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      maxWidth: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isBrowser && shrinkPageName;
  let t8;
  if ($[6] !== t7) {
    t8 = classNames("origin-left transform transition-transform ease-in-out delay-150 text-xl font-bold md:text-2xl scale-100", "max-md:whitespace-normal max-md:break-words", "md:whitespace-nowrap", {
      "md:!scale-90": t7
    });
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== pageName || $[9] !== t8) {
    t9 = <h1 className={t8} data-xc="ProductListingPageName" ref={titleRef}>{pageName}</h1>;
    $[8] = pageName;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t9) {
    t10 = <div className={t4} data-xc="ProductListingPageNameContainer" style={t6}>{t9}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
ProductListingPageName.propTypes = {
  loading: PropTypes.bool,
  pageName: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default ProductListingPageName;